import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { PlatformTools } from "../platform/PlatformTools";
/**
 * Performs logging of the events in TypeORM.
 * This version of logger uses console to log events and use syntax highlighting.
 */
export var AdvancedConsoleLogger = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function AdvancedConsoleLogger(options) {
    _classCallCheck(this, AdvancedConsoleLogger);
    this.options = options;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Logs query and parameters used in it.
   */
  _createClass(AdvancedConsoleLogger, [{
    key: "logQuery",
    value: function logQuery(query, parameters, queryRunner) {
      if (this.options === "all" || this.options === true || Array.isArray(this.options) && this.options.indexOf("query") !== -1) {
        var sql = query + (parameters && parameters.length ? " -- PARAMETERS: " + this.stringifyParams(parameters) : "");
        PlatformTools.logInfo("query:", PlatformTools.highlightSql(sql));
      }
    }
    /**
     * Logs query that is failed.
     */
  }, {
    key: "logQueryError",
    value: function logQueryError(error, query, parameters, queryRunner) {
      if (this.options === "all" || this.options === true || Array.isArray(this.options) && this.options.indexOf("error") !== -1) {
        var sql = query + (parameters && parameters.length ? " -- PARAMETERS: " + this.stringifyParams(parameters) : "");
        PlatformTools.logError("query failed:", PlatformTools.highlightSql(sql));
        PlatformTools.logError("error:", error);
      }
    }
    /**
     * Logs query that is slow.
     */
  }, {
    key: "logQuerySlow",
    value: function logQuerySlow(time, query, parameters, queryRunner) {
      var sql = query + (parameters && parameters.length ? " -- PARAMETERS: " + this.stringifyParams(parameters) : "");
      PlatformTools.logWarn("query is slow:", PlatformTools.highlightSql(sql));
      PlatformTools.logWarn("execution time:", time);
    }
    /**
     * Logs events from the schema build process.
     */
  }, {
    key: "logSchemaBuild",
    value: function logSchemaBuild(message, queryRunner) {
      if (this.options === "all" || Array.isArray(this.options) && this.options.indexOf("schema") !== -1) {
        PlatformTools.log(message);
      }
    }
    /**
     * Logs events from the migration run process.
     */
  }, {
    key: "logMigration",
    value: function logMigration(message, queryRunner) {
      PlatformTools.log(message);
    }
    /**
     * Perform logging using given logger, or by default to the console.
     * Log has its own level and message.
     */
  }, {
    key: "log",
    value: function log(level, message, queryRunner) {
      switch (level) {
        case "log":
          if (this.options === "all" || Array.isArray(this.options) && this.options.indexOf("log") !== -1) PlatformTools.log(message);
          break;
        case "info":
          if (this.options === "all" || Array.isArray(this.options) && this.options.indexOf("info") !== -1) PlatformTools.logInfo("INFO:", message);
          break;
        case "warn":
          if (this.options === "all" || Array.isArray(this.options) && this.options.indexOf("warn") !== -1) console.warn(PlatformTools.warn(message));
          break;
      }
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Converts parameters to a string.
     * Sometimes parameters can have circular objects and therefore we are handle this case too.
     */
  }, {
    key: "stringifyParams",
    value: function stringifyParams(parameters) {
      try {
        return JSON.stringify(parameters);
      } catch (error) {
        // most probably circular objects in parameters
        return parameters;
      }
    }
  }]);
  return AdvancedConsoleLogger;
}();